<template>
  <!-- Звёзды: только показ (value, дробное - закрашивается пропорционально) или
       выбор (interactive, v-model: modelValue 1..5). -->
  <div v-if="!interactive" class="inline-flex items-center gap-0.5" role="img" :aria-label="`${value ?? 0} / 5`">
    <span v-for="n in 5" :key="n" class="relative inline-block" :style="{ width: `${size}px`, height: `${size}px` }">
      <Star :size="size" class="absolute inset-0 text-border" aria-hidden="true" />
      <span class="absolute inset-0 overflow-hidden" :style="{ width: `${fill(n)}%` }">
        <Star :size="size" class="text-amber-500 fill-current" aria-hidden="true" />
      </span>
    </span>
  </div>
  <div v-else class="inline-flex items-center gap-1" role="radiogroup" :aria-label="label">
    <button
      v-for="n in 5"
      :key="n"
      type="button"
      role="radio"
      :aria-checked="modelValue === n"
      :aria-label="`${n}`"
      class="p-0.5 rounded outline-none focus-visible:ring-2 focus-visible:ring-ring"
      @click="$emit('update:modelValue', n)"
    >
      <Star :size="size" class="text-amber-500" :class="n <= (modelValue ?? 0) && 'fill-current'" aria-hidden="true" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { Star } from "lucide-vue-next";

const props = withDefaults(
  defineProps<{ value?: number | null; modelValue?: number | null; interactive?: boolean; size?: number; label?: string }>(),
  { size: 16 }
);
defineEmits<{ (e: "update:modelValue", v: number): void }>();

// Доля закраски n-й звезды, %.
const fill = (n: number) => Math.max(0, Math.min(1, (props.value ?? 0) - (n - 1))) * 100;
</script>
